import { TYPES } from '@/config/billing/creditCard';

/**
 * Get credit card type info
 */
export const getCreditCardTypeInfo = type => TYPES[type];
